export default function SkeletonCard() {
  return (
    <div className="image-card skeleton-card" aria-hidden="true">
      <div className="skeleton-block skeleton-media" />
      <div className="image-card-body">
        <div className="skeleton-block skeleton-pill" />
        <div className="skeleton-block skeleton-line" />
        <div className="skeleton-block skeleton-line short" />
      </div>
    </div>
  );
}
